import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PromoCodeConsentComponent extends Component {
  static readonly TYPE_ID: string = '80984e4dbb104ddc89c350c500d0e90c';

  constructor(
    public readonly title: LocalizedString,
    public readonly description: LocalizedString,
    public readonly acceptButtonLabel: LocalizedString,
    public readonly declineButtonLabel: LocalizedString,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return PromoCodeConsentComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PromoCodeConsentComponent {
    return new PromoCodeConsentComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'title')),
        context.fromData(MapUtils.get<SerializedData>(map, 'description')),
        context.fromData(MapUtils.get<SerializedData>(map, 'acceptButtonLabel')),
        context.fromData(MapUtils.get<SerializedData>(map, 'declineButtonLabel')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'title': context.toData(this.title),
      'description': context.toData(this.description),
      'acceptButtonLabel': context.toData(this.acceptButtonLabel),
      'declineButtonLabel': context.toData(this.declineButtonLabel),
    };
  }

  clone(): this {
    return new PromoCodeConsentComponent(
        this.title.clone(),
        this.description.clone(),
        this.acceptButtonLabel.clone(),
        this.declineButtonLabel.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.title, this.title) &&
        isSameData(other.description, this.description) &&
        isSameData(other.acceptButtonLabel, this.acceptButtonLabel) &&
        isSameData(other.declineButtonLabel, this.declineButtonLabel);
  }
}

export class PromoCodeConsentComponentBuilder extends DataModelBuilder<PromoCodeConsentComponent> {
  build(context: SerializationContext, map: SerializedData): PromoCodeConsentComponent {
    return PromoCodeConsentComponent.fromMap(context, map);
  }
}
